export default "__VITE_ASSET__ae96649f__"